import { render } from "./rendimentoFinal.vue?vue&type=template&id=0a264b57&scoped=true"
import script from "./rendimentoFinal.vue?vue&type=script&lang=js"
export * from "./rendimentoFinal.vue?vue&type=script&lang=js"

import "./rendimentoFinal.vue?vue&type=style&index=0&id=0a264b57&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a264b57"]])

export default __exports__